import {BaseDTO} from '../../common/models/BaseDTO';
import {IssueTicketDTO} from './IssueTicketDTO';

export class IssueTicketCaseLinkDTO extends BaseDTO {
  caseId: number | bigint;
  issueTicketDTO: IssueTicketDTO;
}
